import { getAllCountries, getCountryForTimezone } from "countries-and-timezones";

export const decodeString = (str = "") => encodeURIComponent(decodeURIComponent(str))?.toLowerCase() || "";
export const isCountryEgypt = (country = "") => decodeString(country) === decodeString("egypt");
export const isCountryCanada = (country = "") => decodeString(country) === decodeString("canada");
export const isStateBritishColumbia = (state = "") => decodeString(state) === decodeString("british columbia");
export const isStateQuebec = (state = "") => decodeString(state) === decodeString("quebec");
export const isStateOntario = (state = "") => decodeString(state) === decodeString("ontario");
export const isStateNovaScotia = (state = "") => decodeString(state) === decodeString("nova scotia");
export const isStateNewBrunswick = (state = "") => decodeString(state) === decodeString("new brunswick");
export const isStatePrinceEdwardIsland = (state = "") => decodeString(state) === decodeString("prince edward island");
export const isStateAlberta = (state = "") => decodeString(state) === decodeString("alberta");
export const isStateNewfoundlandAndLabrador = (state = "") =>
	decodeString(state) === decodeString("newfoundland and labrador");
export const isStateYukon = (state = "") => decodeString(state) === decodeString("yukon");
export const isStateSaskatchewan = (state = "") => decodeString(state) === decodeString("saskatchewan");
export const isStateNunavut = (state = "") => decodeString(state) === decodeString("nunavut");
export const isStateNorthwestTerritories = (state = "") =>
	decodeString(state) === decodeString("northwest territories");
export const isStateManitoba = (state = "") => decodeString(state) === decodeString("manitoba");
export const getTimezone = () => Intl.DateTimeFormat()?.resolvedOptions()?.timeZone || "";
export const getCountryUsingTimezone = () => getCountryForTimezone(getTimezone()) || "";
export const getCountryCodeUsingName = (countryName = "") =>
	(countryName &&
		Object.values(getAllCountries()).find(
			(country) => country.name?.toLowerCase() === countryName?.toLowerCase()
		)) ||
	{};
export const getCountryStateCityIdUsingName = ({ list = [], title = "" }) =>
	[...(list || [])].find(({ name }) => name?.toLowerCase() === decodeURIComponent(title)?.toLowerCase())?.id || "";
export const getCountryIdUsingTimezone = ({ list = [] }) =>
	[...(list || [])].find(({ name }) => name?.toLowerCase() === getCountryUsingTimezone()?.name?.toLowerCase())?.id ||
	"";
export const getCountryCodeUsingId = ({ list = [], id = "" }) =>
	[...(list || [])].find(({ id: identifier }) => +id === +identifier)?.code || "";
export const getCountryIdUsingName = ({ list = [], title = "" }) =>
	getCountryStateCityIdUsingName({ list, title }) || getCountryIdUsingTimezone({ list }) || "";
export const getCountryStateCityNameUsingId = ({ list = [], id = "" }) =>
	encodeURIComponent([...(list || [])].find(({ id: identifier }) => +id === +identifier)?.name || "");
export const getPatientHealthCardNumberMaxLengthUsingState = (state = "") =>
	isStateNorthwestTerritories(state)
		? 7
		: isStatePrinceEdwardIsland(state)
		? 8
		: isStateAlberta(state) ||
		  isStateNewBrunswick(state) ||
		  isStateNunavut(state) ||
		  isStateSaskatchewan(state) ||
		  isStateYukon(state)
		? 9
		: isStateBritishColumbia(state) || isStateNovaScotia(state) || isStateOntario(state)
		? 10
		: isStateNewfoundlandAndLabrador(state) || isStateQuebec(state)
		? 12
		: 0;
